import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { ThemeProvider } from "./components/theme-provider";
import PWAUpdatePrompt from "./components/PWAUpdatePrompt";
import "./index.css";

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

// Service-worker registration + update handling lives in <PWAUpdatePrompt />,
// which owns the lifecycle and renders the "Update available" prompt.

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <App />
      <PWAUpdatePrompt />
    </ThemeProvider>
  </QueryClientProvider>
);
